import { Injectable, Inject } from '@angular/core';
import { BaseService } from './base.service';


@Injectable()
export class SortingresultsService {
    constructor(private bs: BaseService) {
        this.bs.log('info',"Loaded SortingresultsService");
    }

    sortResults(data:any, key:any) {
        return data.sort(function (a:any, b:any) {    
          var x = a[key];
          var y = b[key];
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    
      }

      sortResultsByDefinedOrder(data:any, key:any, asc:any) {
        return data.sort(function(a:any, b:any) {
            if (asc) {
                return (a[key] > b[key]) ? 1 : ((a[key] < b[key]) ? -1 : 0);
            } else {
                return (b[key] > a[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0);
            }
        });
        
    }
}
